import React, { useEffect, useState } from 'react';
import {
  AppBarItem,
  Link,
  Menu,
  MenuItem,
  NavigationTheme,
  Toolbar,
  Typography,
} from '@dls/react-core';
import { Icon } from '@dls/react-icon';
import { AppBar } from '@dls/react-core';
import { Settings as SettingsIcon } from '@dls/react-icons';
import { RoutePaths } from '../../routes/main-routes';
import { useNavigate, useLocation } from 'react-router-dom';
import { ColorDLS, ColorX11 } from '../../styling/color';
import styled from 'styled-components';
import { HasPermission } from '../../context/authorization';
import { getCurrentUser, signOut } from 'aws-amplify/auth';

const StyledMenuItemsContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
interface NavItem {
  path: string;
  label: string;
}

const NAV_ITEMS: NavItem[] = [
  {
    path: RoutePaths.Studies,
    label: 'Studies',
  },
];

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState<string>();

  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    getCurrentUser().then((user) => {
      setUsername(user.signInDetails?.loginId || 'User');
    });
  }, []);

  const handleLogout = async () => {
    setAnchorEl(null);
    await signOut();
    window.location.href = '/login';
  };

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          backgroundColor: ColorDLS.Blue45,
          width: '100%',
          height: '112px',
          zIndex: -1,
        }}
      />
      <NavigationTheme>
        <AppBar position="static" color="primary">
          <Toolbar
            className={'dls-toolbar-container'}
            style={{ height: 48, justifyContent: `space-between` }}
          >
            <StyledMenuItemsContainer>
              <Typography
                variant="h4"
                weight="weight-300"
                style={{
                  paddingLeft: 24,
                  paddingRight: 24,
                  marginBottom: 0,
                }}
              >
                Philips Studykit
              </Typography>
              {NAV_ITEMS.map((item) => (
                <AppBarItem
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  active={location.pathname.startsWith(`/${item.path}`)}
                >
                  {item.label}
                </AppBarItem>
              ))}
            </StyledMenuItemsContainer>
            <StyledMenuItemsContainer>
              <HasPermission value="Algorithms.Read">
                <AppBarItem
                  data-testid="settings-link"
                  style={{ marginRight: `8px` }}
                  onClick={() => navigate(RoutePaths.Settings)}
                  active={location.pathname.startsWith(`/${RoutePaths.Settings}`)}
                >
                  <SettingsIcon height={24} width={24} fill={ColorX11.White} />
                </AppBarItem>
              </HasPermission>
              <Typography style={{ paddingLeft: 24, paddingRight: 24 }} onClick={handleMenuClick}>
                {username ? username : 'User'}
                <span style={{ marginLeft: `8px` }}>
                  <Icon name="NavigationDown" size={'m'} />
                </span>
              </Typography>
              <Menu
                id="default-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                PaperProps={{
                  className: 'DLSMenuList',
                }}
              >
                <MenuItem key={'logout'} onClick={() => handleLogout()}>
                  <Typography>
                    <Link className={'noUnderLineLink'}>Log out</Link>
                  </Typography>
                </MenuItem>
              </Menu>
            </StyledMenuItemsContainer>
          </Toolbar>
        </AppBar>
      </NavigationTheme>
    </>
  );
};
